var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"city",on:{"click":_vm.selectCity}},[_c('span',{staticClass:"f14"},[_vm._v(_vm._s(_vm.city))]),(_vm.flag)?_c('img',{staticClass:"down",attrs:{"src":require("@/assets/images/right.png")}}):_c('img',{attrs:{"src":require("@/assets/images/more.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }